import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import styled from "styled-components";
import LoadingButton from "@mui/lab/LoadingButton";
import Box from "@mui/material/Box";
import { useKeycloak } from "@react-keycloak/web";
import Input from "../../../shared-components/form/Input";
import { clientAxios8080 } from "../../../configs/axios";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

const Field = styled(Box)`
  width: 100%;
  margin: 15px 0;
  & label {
    display: inline-block;
    margin-bottom: 5px;
    font-size: 13px;
    font-weight: 500;
  }
`;

export default function AddFolder({
  folderId,
  handleClose,
  fromDirectory,
  tabSelectedHandle,
}) {
  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm();
  const { keycloak } = useKeycloak();

  const [mainDirectory, setMainDirectory] = useState([]);
  const [isFormComplete, setIsFormComplete] = useState(false);

  const getFolders = () => {
    return clientAxios8080
      .get("/ms-repositorio/app/structure/directory/get?idUsuario=1")
      .then((response) => {
        const folders = response.data.data.root.children;

        // Order Folders By A-Z
        const sortedFolders =
          folders &&
          folders?.toSorted((a, b) => {
            return a.nameDirectory.localeCompare(b.nameDirectory);
          });

        setMainDirectory(sortedFolders);
      })
      .catch((error) => console.log("error", error));
  };

  // Get Estructure Folder (API)
  useEffect(() => {
    getFolders();
  }, []);

  useEffect(() => {
    const subscription = watch((value) => {
      if (value.nameDirectory && value.status) {
        setIsFormComplete(true);
      }else{
        setIsFormComplete(false);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const [loading, setLoading] = useState(false);

  const onSubmit = (dataForm) => {
    setLoading(true);
    const info = {
      idUsuario: keycloak?.tokenParsed?.sub,
      isPrivate: dataForm.status === "true",
      nameDirectory: dataForm.nameDirectory,
      parent: {
        id: parseFloat(folderId),
      },
    };
    // Create Folder (API)
    clientAxios8080
      .post("/ms-repositorio/file/create/directory/", info)
      .then((response) => {
        console.log("data", response.data);
        tabSelectedHandle(folderId);
        handleClose();
      })
      .catch((error) => console.log("error", error));
  };

  return (
    <Box>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Field>
          <label>Nombre de la carpeta</label>
          <Input
            type="text"
            register={register}
            errors={errors}
            keyName="nameDirectory"
            placeholder="Escribe el nombre de la carpeta"
            required
          />
        </Field>
        <Field>
          <label>Seleccione el status</label>
          <Controller
            name="status"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <Box>
                <FormControl fullWidth>
                  <Select
                    id="mui-component-select-principal-directory"
                    variant="outlined"
                    {...field}
                  >
                    <MenuItem value="true">Privado</MenuItem>
                    <MenuItem value="false">Publico</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            )}
          />
        </Field>
        <LoadingButton
          variant="contained"
          color="success"
          type="submit"
          loading={loading}
          disabled={!isFormComplete}
          fullWidth
        >
          <span>Crear Carpeta</span>
        </LoadingButton>
      </form>
    </Box>
  );
}

